import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const CasheLoanPlanModal = ({ show, onClose, preApprovedAmount, cashePlans, onPlanSelect }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const normalizeLoanType = (loanType) => (loanType || '').replace(/\s+/g, '_');

  useEffect(() => {
    if (show) {
      setSelectedPlan(null); // Reset selected plan when modal opens
    }
  }, [show]);

  const handlePlanChange = (e) => {
    const selectedLoanType = e.target.value;
    const plan = cashePlans.find(p => normalizeLoanType(p.loanType) === selectedLoanType);
    setSelectedPlan(plan);
  };

  const handleProceed = () => {
    if (selectedPlan) {
      onPlanSelect(selectedPlan);
      onClose(); // Close the modal after selecting a plan and proceeding
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="cashe-loan-plan-modal">
      <Modal.Header closeButton>
        <Modal.Title className="text-center w-100 cashe-modal-title">Select a Loan Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="cashe-preapproved-message">Congratulations! You are pre-approved for an amount of ₹{preApprovedAmount}.</h5>

        <Form>
          {cashePlans && cashePlans.length > 0 ? (
            [...cashePlans]
              .sort((a, b) => (parseInt(a?.noOfInstallments) || 0) - (parseInt(b?.noOfInstallments) || 0))
              .map((plan, index) => (
              <div key={index} className="mb-1 cashe-loan-plan-option">
                <Form.Check
                  type="radio"
                  id={`plan-${index}`}
                  name="loanPlan"
                  value={normalizeLoanType(plan.loanType)}
                  label={
                    <div>
                      <strong> Installments: {plan.noOfInstallments}</strong> <br />
                      {/* Min: ₹{plan.minLoanEligibilityAmount}, Max: ₹{plan.maxLoanEligibilityAmount} <br /> */}
                      Interest: <strong>{plan.interestRate}</strong><br /> Processing Fee: <strong>{plan.processingFee}</strong>
                    </div>
                  }
                  checked={normalizeLoanType(selectedPlan?.loanType) === normalizeLoanType(plan.loanType)}
                  onChange={handlePlanChange}
                  className="cashe-radio-input"
                />
              </div>
            ))
          ) : (
            <p className="text-center">No loan plans available.</p>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={onClose} className="cashe-modal-cancel-btn">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleProceed} disabled={!selectedPlan} className="cashe-modal-proceed-btn">
          Proceed
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CasheLoanPlanModal;
